/** Route pageName без i18n-суффикса; доступны на mobile (+ ACL). */
export const MOBILE_ALLOWED_PAGES = [
  'index',
  'account-profile',
  'account-wallet',
  'account-reports',
  'account-ma-alias',
] as const;

export type MobileAllowedPage = (typeof MOBILE_ALLOWED_PAGES)[number];

export function isMobileAllowedPage(pageName: string): boolean {
  if ((MOBILE_ALLOWED_PAGES as readonly string[]).includes(pageName)) {
    return true;
  }

  // После подстановки params: account-ma-unilevel и т.п.
  if (pageName.startsWith('account-ma-')) {
    return true;
  }

  return false;
}
